import React from 'react';
import PropTypes from 'prop-types';
import LocationPin from 'components/ui/icons/LocationPin';
import { IconWrapper } from './styles';

const Location = ({ location }) => {
  return (
    <div className="d-flex">
      <IconWrapper>
        <LocationPin />
      </IconWrapper>
      <div>
        {<span className="mr-2 text-nowrap d-inline-block">{location}</span>}
      </div>
    </div>
  );
};

Location.propTypes = {
  location: PropTypes.string.isRequired,
};

export default Location;
